module.exports = __webpack_public_path__ + "static/seo-hero.9ceaa855.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/seo-hero.png
// module id = 934
// module chunks = 241767136424496